/* eslint-disable react/no-unknown-property */
import { Accordion } from 'flowbite-react';
import { Link } from 'react-router-dom';

export default function Faqsection() {
  return (
   <>
   <br></br>
   <div class="mx-auto">
      <div  class="mt-[6px] text-orange-600 body-font  ">
      <h3 class="text-center lg:text-[22px] font-bold sm:text-3xl"> FAQ     </h3>
        </div>
      </div>

  <Accordion className="p-4" >
      <Accordion.Panel >
        <Accordion.Title className=" text-orange-900" > What is SiteKitPro? </Accordion.Title>
        <Accordion.Content>
          <p className="mb-2 text-gray-500 dark:text-gray-400">
          SiteKit offers themes, plugins, sitekits, and other high-quality resources. Sitekit Pro allows you to create a complete premium website in a single day with an installation process that takes only an hour and at a cost that is reasonable. 
          </p>
           
        </Accordion.Content>
      </Accordion.Panel>
      <Accordion.Panel>
        <Accordion.Title className=" text-orange-900" > Do I need to any license?</Accordion.Title>
        <Accordion.Content>
          <p className="mb-2 text-gray-500 dark:text-gray-400">
          All Sitekit, plugins and themes are available for usage without a license. since we are taking care of it since we created it or got it from a safe source for you. You can rely on us to download anything from Sitekitpro.
 
          </p>
        
        </Accordion.Content>
      </Accordion.Panel>
      <Accordion.Panel>

        <Accordion.Title className=" text-orange-900 " >  How long do I get support?  </Accordion.Title>
        <Accordion.Content>
          <p className="mb-2 text-gray-500 dark:text-gray-400">
          Just Visit <Link to="/contact" className='font-bold text-[16px] text-green-700'  >Contact 
           </Link> Get help from us anytime by just contacting us at or complete contact form.
         
          </p>
             
        </Accordion.Content>
      </Accordion.Panel>

      <Accordion.Panel>

<Accordion.Title className=" text-orange-900" >How to Download any themes, Sitekit & Plugins and installation ?</Accordion.Title>
<Accordion.Content>
  <p className="mb-2 text-gray-500 dark:text-gray-400">
  SiteKitPro Get Installation and Downloading with help of video and manual anyone can get your site active and any issue fixed.
 
  </p>
    
   
</Accordion.Content>
</Accordion.Panel>

 
    </Accordion>
   </>
  )
}
 